import React from "react";

const AppLogoImg = require("./../images/app-logo.png");

export default function AppLogo({ isMobile }: { isMobile: boolean }) {
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <img
        src={AppLogoImg}
        width="100%"
        alt="app-logo"
        style={{ objectFit: "contain" }}
      />
    </div>
  );
}
